import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import App from './App'
import { queryClient } from './lib/query-client'
import { CrashBoundary } from './components/crash-boundary'
import './index.css'
import { ThemeProvider } from './components/theme-provider'

function CrashFallback() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center">
      <p className="text-lg">Сторінку не вдалося відобразити.</p>
      <button type="button" className="underline" onClick={() => window.location.reload()}>
        Оновити сторінку
      </button>
    </div>
  )
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider defaultTheme="dark" storageKey="mphelper-dashboard-theme">
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <CrashBoundary fallback={<CrashFallback />}>
            <App />
          </CrashBoundary>
        </BrowserRouter>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>
)
